<template>
  <Toast />
  <ConfirmDialog></ConfirmDialog>
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">VENTAS</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">DETALLE DE VENTAS</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12 border-2">
    <div class="flex align-items-center flex-column lg:justify-content-center lg:flex-row">
      <h4>
        <strong>DETALLE DE VENTA: #{{ venta.id }} - </strong>
        <span v-if="venta.tipo_pago_nombre == 'PAGO AL CONTADO'" style="color: #28a745">
          {{ venta.tipo_pago_nombre }}
        </span>
        <span v-else-if="venta.tipo_pago_nombre == 'PAGO AL CRÉDITO'" style="color: #dc3545">
          {{ venta.tipo_pago_nombre }}
        </span>
      </h4>
    </div>
    <div class="grid style_card" style="background-color: #f8f9fa">
      <div class="col-4">
        <p class="mb-0">
          <strong>RAZ&Oacute;N SOCIAL: </strong>
          <span>{{ venta.razon_social }}</span>
        </p>
        <p class="mb-0">
          <strong>NIT/CI: </strong> <span>{{ venta.nit }}</span>
        </p>
      </div>
      <div class="col-4">
        <p class="mb-0">
          <strong>FECHA VENTA: </strong>
          <span>{{ venta.fecha_venta }}</span>
        </p>
        <p class="mb-0">
          <strong>VENDEDOR: </strong>
          <span>{{ venta.nombre_usuario_caja }}</span>
        </p>
      </div>
      <div class="col-4">
        <p class="mb-0">
          <strong>ESTADO: </strong>
          <span
            v-if="venta.estado == 1"
            style="background-color: #28a745; color: white; padding: 2px; border-radius: 5px; font-weight: bold"
            class="badge"
          >
            {{ venta.estado_texto }}</span
          >
          <span
            v-else
            style="background-color: #dc3545; color: white; padding: 2px; border-radius: 5px; font-weight: bold"
            class="badge"
            >{{ venta.estado_texto }}</span
          >
        </p>
        <p class="mb-0">
          <strong>RECIBO/FACTURA: </strong>
          <span>{{ venta.nrofactura }}</span>
        </p>
      </div>
    </div>
    <div class="grid mt-2">
      <DataTable
        ref="ventas"
        :value="productos"
        class="col-12 p-datatable-sm"
        responsiveLayout="scroll"
        stripedRows
        showGridlines
        selectionMode="single click"
        editMode="cell"
        @cell-edit-complete="onChangeEditandoCelda"
      >
        <Column field="codigo_interno" header="C&Oacute;D.">
          <template #body="slotProps">
            {{ slotProps.data.codigo_interno ? slotProps.data.codigo_interno : slotProps.data.id }}
          </template>
        </Column>
        <Column field="fabrica_nombre" header="LABORATORIO">
          {{ producto.fabrica_nombre ?? '-' }}
        </Column>
        <Column field="descripcion" header="PRODUCTO/DESCRIPCIÓN" style="font-weight: bold">
          {{ producto.descripcion }}
        </Column>
        <Column field="unidad_medida_nombre" header="U.MEDIDA"> </Column>
        <Column field="pivot.fecha_vence" header="FECHA.VENC." style="text-align: center">
          <template #body="slotProps">
            {{
              slotProps.data.pivot.fecha_vence == '1905-03-14' ? '-' : formatoFecha(slotProps.data.pivot.fecha_vence)
            }}
          </template>
        </Column>
        <Column field="pivot.cantidad" header="CANTIDAD" style="text-align: right">
          <template #body="slotProps">
            <span style="font-weight: bold; font-size: 1rem">
              {{ convertirNumeroGermanicFormat(slotProps.data.pivot.cantidad) }}
            </span>
          </template>
        </Column>
        <Column
          v-if="acciones_eliminar"
          class="bg-green-200"
          field="cantidad_devolucion"
          header="CANT.DEVOL."
          style="font-weight: bold; text-align: right"
        >
          <template #editor="{ data }">
            <InputNumber
              :inputClass="'text-right'"
              :min="0"
              locale="de-ED"
              v-model="data.cantidad_devolucion"
              v-tooltip.top="'Cantidad a devolver'"
              class="p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="pivot.precio" header="PRECIO" style="text-align: right">
          <template #body="slotProps">
            <span style="font-weight: bold; font-size: 1rem">
              {{ convertirNumeroGermanicFormat(slotProps.data.pivot.precio) }}
            </span>
          </template>
        </Column>
        <Column field="pivot.descuento_neto" header="DESC." style="text-align: right">
          <template #body="slotProps">
            <span style="font-weight: bold; font-size: 1rem">
              {{ convertirNumeroGermanicFormat(slotProps.data.pivot.descuento_neto ?? 0) }}
            </span>
          </template>
        </Column>
        <Column header="TOTAL" style="text-align: right">
          <template #body="slotProps">
            <span style="font-weight: bold; font-size: 1rem">
              {{
                convertirNumeroGermanicFormat(
                  slotProps.data.pivot.cantidad * slotProps.data.pivot.precio - slotProps.data.pivot.descuento_neto
                )
              }}
            </span>
          </template>
        </Column>
      </DataTable>
    </div>
    <div class="grid align-items-start mt-1">
      <div class="col-12 md:col-8" v-if="descuentosAplicados && descuentosAplicados.length > 0">
        <div class="surface-card border-1 border-300 border-round h-full p-2 flex flex-column justify-content-between">
          <div>
            <div class="text-700 font-bold text-sm mb-2 border-bottom-1 surface-border pb-1">
              <i class="pi pi-tag mr-1"></i>DETALLE DESCUENTOS
            </div>

            <div v-for="(desc, index) in descuentosAplicados" :key="index" class="mb-2">
              <!-- Una sola línea con toda la info -->
              <div class="flex align-items-center justify-content-between mb-1">
                <span class="font-bold text-900 text-sm">
                  Desc. {{ index + 1 }}
                  {{ desc.descuento_config ? desc.descuento_config.nombre : '' }}
                </span>

                <div class="flex align-items-center gap-2">
                  <span class="bg-blue-50 border-1 border-blue-200 text-blue-700 px-2 border-round font-bold text-sm">
                    {{ parseFloat(desc.porcentaje_aplicado) }}%
                  </span>

                  <span v-if="desc.fecha_vencimiento" class="text-red-600 font-bold text-xs white-space-nowrap">
                    Vence:
                    {{ formatoFecha(desc.fecha_vencimiento.toString().substring(0, 10)) }}
                  </span>
                </div>
              </div>

              <!-- Mensaje de advertencia solo para el primer descuento -->
              <div
                v-if="index === 0 && desc.descuento_config && desc.descuento_config.mensaje_advertencia"
                class="mt-1 bg-yellow-50 p-1 border-round text-700 text-xs border-left-2 border-yellow-400"
                style="font-style: italic; line-height: 1.2; font-weight: bold"
              >
                {{ desc.descuento_config.mensaje_advertencia }}
              </div>
            </div>
          </div>

          <div v-if="descuentosAplicados.length > 1" class="border-top-1 surface-border mt-1 pt-1 text-right">
            <span class="text-600 text-xs font-bold mr-2">Descuentos aplicados:</span>
            <span class="text-blue-800 font-bold text-base bg-blue-50 px-2 border-round border-1 border-blue-100">
              {{ descuentosAplicados.reduce((total, item) => total + parseFloat(item.porcentaje_aplicado), 0) }}%
            </span>
          </div>
        </div>
      </div>

      <div
        :class="
          descuentosAplicados && descuentosAplicados.length > 0 ? 'col-12 md:col-4' : 'col-12 md:col-offset-8 md:col-4'
        "
      >
        <table class="w-full" style="border-collapse: collapse; font-size: 1rem">
          <tbody>
            <tr>
              <td class="p-1 border-1 border-300 surface-100 font-bold text-700 text-right w-6">SUBTOTAL Bs:</td>
              <td class="p-1 border-1 border-300 bg-white text-right text-900">
                {{ convertirNumeroGermanicFormat(subtotal) }}
              </td>
            </tr>

            <tr>
              <td class="p-1 border-1 border-300 surface-100 font-bold text-700 text-right">DESCUENTO Bs:</td>
              <td class="p-1 border-1 border-300 bg-white text-right">
                <span class="text-green-600 font-bold">
                  {{ convertirNumeroGermanicFormat(venta.descuento) }}
                </span>
              </td>
            </tr>

            <tr v-if="venta.tipo_pago_id == 2">
              <td class="p-1 border-1 border-300 surface-100 font-bold text-700 text-right">A CUENTA Bs:</td>
              <td class="p-1 border-1 border-300 bg-white text-right text-900">
                {{ convertirNumeroGermanicFormat(venta.total_pagos) }}
              </td>
            </tr>

            <tr>
              <td class="p-1 border-1 border-blue-300 bg-blue-50 font-bold text-800 text-right">
                MONTO {{ venta.tipo_pago_id == 1 ? 'CANCELAR' : 'DEBE' }} Bs:
              </td>
              <td class="p-1 border-1 border-blue-300 bg-white text-right">
                <span class="text-lg font-bold text-900">
                  {{
                    convertirNumeroGermanicFormat(
                      venta.tipo_pago_id == 1 ? venta.total_cancelar : venta.total_cancelar - venta.total_pagos
                    )
                  }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="grid mt-3">
      <div class="field col-12 md:col-6">
        <div class="flex align-items-end justify-content-start" v-if="'Venta Anular' in auth.user.permissions">
          <Button
            v-if="venta.estado == 1 && 'Venta Anular' in auth.user.permissions"
            icon="pi pi-trash"
            :class="{
              'p-button-danger': !acciones_eliminar,
              'p-button-secondary': acciones_eliminar
            }"
            v-tooltip.top="'Acciones de Anulación'"
            @click="acciones_eliminar == false ? (acciones_eliminar = true) : (acciones_eliminar = false)"
          />
          <Button
            v-if="acciones_eliminar"
            icon="pi pi-trash"
            label="ANULAR VENTA"
            class="p-button-danger mr-1 ml-1"
            v-tooltip.top="'Anular Venta'"
            @click="anularVenta(venta.id)"
            :loading="anulando"
          />
          <Button
            v-if="acciones_eliminar && venta.tipo_pago_id == 2"
            icon="pi pi-check"
            label="DEVOLVER SELECCIONADOS"
            class="p-button-info"
            v-tooltip.top="'Devolver Seleccionados'"
            @click="devolverProductosSeleccionados(venta.id)"
            :loading="devolviendo"
          />
        </div>
      </div>

      <div class="field col-12 md:col-6">
        <div class="flex align-items-end justify-content-end">
          <Button
            @click="goBack"
            class="p-button-info p-button-sm"
            icon="pi pi-arrow-left"
            label="ATR&Aacute;S"
            v-tooltip.top="'Volver a Ventas'"
          >
          </Button>
          <Button
            v-if="printerName && venta.facturado == 0"
            label="IMPRIMIR"
            icon="pi pi-print"
            class="p-button-sm p-button-warning ml-1"
            v-tooltip.top="'Imprimir Venta'"
            @click="imprimirDirecto(venta.id)"
            :loading="imprimiendoDirecto"
          ></Button>
          <Button
            v-if="venta.facturado == 1"
            label="IMPRIMIR"
            icon="pi pi-print"
            class="p-button-sm p-button-warning ml-1"
            v-tooltip.top="'Imprimir Ticket Directo'"
            @click="imprimirDirecto2(venta.id)"
            :loading="imprimiendoDirecto"
          />
          <Button
            v-if="venta.facturado == 1"
            label="IMPRIMIR TICKET"
            icon="pi pi-file-pdf"
            class="p-button-sm p-button-success ml-1"
            v-tooltip.top="'Imprimir Ticket'"
            @click="imprimirVenta2(venta.id)"
            :loading="imprimiendoTiket"
          />
          <Button
            v-if="'Venta Facturar' in auth.user.permissions && venta.facturado == 0"
            label="CREAR FACTURA"
            icon="pi pi-book
"
            class="p-button-sm p-button-secondary ml-2"
            v-tooltip.top="'Crear Factura'"
            @click="ventaFacturar(venta)"
          >
          </Button>
          <Button
            v-if="'Venta Facturar' in auth.user.permissions && venta.facturado == 1 && venta.cuf"
            icon="pi pi-check-circle"
            class="p-button-sm p-button-danger ml-2"
            v-tooltip.top="'Verificar Estado de Factura'"
            @click="verificarEstado({ venta_id: venta.id })"
          >
          </Button>
          <Button
            :label="venta.facturado == 1 ? 'IMPRIMIR FACTURA' : 'DESCARGAR PDF'"
            icon="pi pi-file-pdf"
            class="p-button-sm p-button-danger ml-2"
            v-tooltip.top="'Imprimir PDF'"
            @click="imprimirVenta(venta.id)"
            :disabled="imprimiendo"
            :loading="imprimiendo"
          >
          </Button>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal VentaFacturar -->
  <VentaFacturar
    v-if="ventafacturaDialog"
    :show="ventafacturaDialog"
    :ventaFactura="ventaFactura"
    @closeModal="ocultarDialog"
    @actualizarListado="cargarVenta"
  />

  <!-- Modal Verificar Estado -->
  <FacturaEstadoVerificacion
    v-if="modalVerificarEstado"
    v-model:visible="modalVerificarEstado"
    :datos="datosVerificacion"
    :loading="verificandoEstado"
    @closed="limpiarDatosVerificacion"
  />
</template>

<script>
import VentaService from '@/service/VentaService'
import { useAuth } from '@/stores'
import VentaFacturar from '@/module/ventas/VentaFacturar.vue'
import FacturaEstadoVerificacion from '@/module/facturas/FacturaEstadoVerificacion.vue'

export default {
  components: {
    VentaFacturar,
    FacturaEstadoVerificacion
  },
  data() {
    return {
      venta: {},
      venta_id: this.$route.params.id,
      productos: [],
      imprimiendo: false,
      acciones_eliminar: false,
      anulando: false,
      devolviendo: false,
      imprimiendoTiket: false,
      imprimiendoDirecto: false,
      printerName: '',
      ventaFactura: {},
      ventafacturaDialog: false,
      // Variables para verificación de factura
      modalVerificarEstado: false,
      datosVerificacion: {},
      verificandoEstado: false,
      descuentosAplicados: []
    }
  },
  ventaService: null,
  auth: null,
  created() {
    this.ventaService = new VentaService()
    this.auth = useAuth()
  },
  mounted() {
    this.cargarVenta()
  },
  computed: {
    subtotal() {
      let subtotal = 0
      this.productos.forEach((producto) => {
        subtotal += producto.pivot.precio * producto.pivot.cantidad
      })
      return subtotal
    }
  },
  methods: {
    verificarEstado(datos) {
      this.modalVerificarEstado = true
      this.verificandoEstado = true

      this.ventaService
        .verificarEstadoFactura(datos.venta_id)
        .then((response) => {
          if (response.status == 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Éxito',
              detail: response.mensaje,
              life: 3000
            })

            this.datosVerificacion = {
              venta_id: datos.venta_id,
              cuf: response.cuf,
              estado: response.estado,
              mensaje: response.mensaje,
              detalles: {
                success: response.detalles?.success,
                invoice: {
                  number: response.detalles?.invoice?.number,
                  total: response.detalles?.invoice?.total,
                  createdAt: response.detalles?.invoice?.createdAt,
                  cuf: response.detalles?.invoice?.cuf,
                  statusCode: response.detalles?.invoice?.statusCode
                },
                siatResponse: {
                  codigoDescripcion: response.detalles?.siatResponse?.codigoDescripcion,
                  codigoEstado: response.detalles?.siatResponse?.codigoEstado,
                  transaccion: response.detalles?.siatResponse?.transaccion,
                  codigoRecepcion: response.detalles?.siatResponse?.codigoRecepcion
                }
              }
            }
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: response.mensaje,
              life: 3000
            })
            this.modalVerificarEstado = false
          }
        })
        .catch((error) => {
          this.modalVerificarEstado = false
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo verificar el estado: ' + (error.message || ''),
            life: 3000
          })
        })
        .finally(() => {
          this.verificandoEstado = false
        })
    },

    // Limpia los datos cuando se cierra el modal
    limpiarDatosVerificacion() {
      this.datosVerificacion = {}
    },

    ventaFacturar(venta) {
      this.ventaFactura = {
        ...venta,
        nit: venta.nit && venta.nit !== '0' && venta.nit !== '99001' ? Number(venta.nit) : null
      }
      this.ventafacturaDialog = true
    },
    ocultarDialog() {
      this.ventafacturaDialog = false
      this.ventaFactura = {} // Limpiar datos
    },
    imprimirDirecto(id) {
      if (this.imprimiendoDirecto) return

      this.imprimiendoDirecto = true

      this.ventaService
        .imprimirDirecto(id, this.printerName)
        .then(() => {})
        .catch((error) => {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: error.message || 'No se pudo imprimir.',
            life: 4000
          })
        })
        .finally(() => {
          this.imprimiendoDirecto = false
        })
    },
    imprimirDirecto2(id) {
      if (this.imprimiendoDirecto) return

      this.imprimiendoDirecto = true

      this.ventaService
        .imprimirDirecto2(id, this.printerName)
        .then(() => {})
        .catch((error) => {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: error.message || 'No se pudo imprimir.',
            life: 4000
          })
        })
        .finally(() => {
          this.imprimiendoDirecto = false
        })
    },
    imprimirVenta2(id) {
      if (this.imprimiendo) {
        return
      }
      this.imprimiendoTiket = true
      this.ventaService.imprimirVenta2(id).then(() => {
        this.imprimiendoTiket = false
      })
    },
    formatoFecha(fecha) {
      let fecha_array = fecha.split('-')
      return `${fecha_array[2]}/${fecha_array[1]}/${fecha_array[0]}`
    },
    devolverProductosSeleccionados(venta_id) {
      let productos = this.productos.filter((producto) => producto.cantidad_devolucion > 0)
      if (productos.length == 0) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No hay productos seleccionados para devolver',
          life: 3000
        })
        return
      }
      this.$confirm.require({
        header: 'CONFIRMACIÓN',
        message: '¿ESTÁS SEGURO DE DEVOLVER LOS PRODUCTOS SELECCIONADOS?',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Si, Devolver',
        rejectLabel: 'No, Cancelar',
        acceptClass: 'p-button-primary p-button-lg',
        rejectClass: 'p-button-danger p-button-lg',
        acceptIcon: 'pi pi-save',
        rejectIcon: 'pi pi-times',
        accept: () => {
          this.devolviendo = true
          let datos = {
            venta_id: venta_id,
            productos: productos
          }
          this.ventaService.devolverProductosSeleccionados(datos).then((response) => {
            if (response.success == false) {
              this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: response.message,
                life: 3000
              })
              this.devolviendo = false
              return
            } else {
              this.$toast.add({
                severity: 'success',
                summary: 'Éxito',
                detail: response.message,
                life: 3000
              })
              this.cargarVenta()
              this.acciones_eliminar = false
              this.devolviendo = false
            }
          })
        }
      })
    },
    anularVenta(id) {
      this.$confirm.require({
        header: 'CONFIRMACIÓN',
        message: '¿ESTÁS SEGURO DE ANULAR ESTA VENTA?',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Si, Anular',
        rejectLabel: 'No, Cancelar',
        acceptClass: 'p-button-primary p-button-lg',
        rejectClass: 'p-button-danger p-button-lg',
        acceptIcon: 'pi pi-save',
        rejectIcon: 'pi pi-times',
        accept: () => {
          this.anulando = true
          this.ventaService.anularVenta(id).then((response) => {
            if (response.status == 200) {
              this.$toast.add({
                severity: 'success',
                summary: 'Éxito',
                detail: response.mensaje,
                life: 3000
              })
              this.cargarVenta()
              this.anulando = false
              this.acciones_eliminar = false
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: response.mensaje,
                life: 3000
              })
              this.anulando = false
              this.acciones_eliminar = false
            }
          })
        }
      })
    },
    onChangeEditandoCelda(e) {
      let { data, newValue, field } = e
      data[field] = newValue
      if (field == 'cantidad_devolucion') {
        if (newValue > data.pivot.cantidad) {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'La cantidad a devolver no puede ser mayor a la cantidad',
            life: 3000
          })
          data.cantidad_devolucion = parseFloat(data.pivot.cantidad)
        }
      }
    },
    imprimirVenta(id) {
      if (this.imprimiendo) {
        return
      }
      this.imprimiendo = true
      this.ventaService.imprimirVenta(id).then(() => {
        this.imprimiendo = false
      })
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2
      }).format(numero)
    },
    cargarVenta() {
      this.ventaService.getVenta(this.venta_id).then((response) => {
        this.venta = response.venta
        this.productos = this.venta.productos
        this.printerName = response.printerName
        this.descuentosAplicados = response.venta.descuentos_aplicados || []
      })
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';

.p-invalid {
  color: red;
}
.style_card {
  border: 1px solid #000000;
  border-bottom: 3px solid #000000;
  padding: 0px;
  background-color: #f8f9fa;
  border-radius: 5px;
}
</style>
